var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "saas_module_plate_nav_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
        "hide-required-asterisk": "",
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "value" } },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(" 设置分类及排序 "),
            _c("span", { staticClass: "tips" }, [
              _vm._v("（拖动分类可调整排序）"),
            ]),
          ]),
          _c(
            "draggable",
            {
              attrs: { animation: "500", "force-fallback": true },
              model: {
                value: _vm.value.config.value,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "value", $$v)
                },
                expression: "value.config.value",
              },
            },
            _vm._l(_vm.value.config.value, function (item, index) {
              return _c(
                "div",
                { key: item.uid || index, staticClass: "category-item" },
                [
                  _c("div", { staticClass: "item-title" }, [
                    _c("span", [_vm._v("分类" + _vm._s(index + 1))]),
                    _vm.value.config.value.length > 1
                      ? _c(
                          "span",
                          {
                            staticClass: "del",
                            on: {
                              click: function ($event) {
                                return _vm.handleDel(index)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-delete" }),
                            _vm._v(" 删除 "),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "展示为",
                        prop: "value." + index + ".name",
                        rules: [
                          {
                            required: true,
                            message: "分类名称不可为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入分类名称",
                          maxlength: "10",
                          clearable: "",
                        },
                        model: {
                          value: item.name,
                          callback: function ($$v) {
                            _vm.$set(item, "name", $$v)
                          },
                          expression: "item.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "展示的SaaS活动板块",
                        prop: "value." + index + ".module_plate_id",
                        rules: [
                          {
                            required: true,
                            message: "活动板块不可为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择板块",
                            clearable: "",
                            filterable: "",
                          },
                          on: {
                            change: function (val) {
                              return _vm.changeModule(val, item)
                            },
                          },
                          model: {
                            value: item.module_plate_id,
                            callback: function ($$v) {
                              _vm.$set(item, "module_plate_id", $$v)
                            },
                            expression: "item.module_plate_id",
                          },
                        },
                        _vm._l(_vm.moduleList, function (option) {
                          return _c("el-option", {
                            key: option.id,
                            attrs: { label: option.name, value: option.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "el-button",
            {
              staticClass: "add-category",
              attrs: { type: "primary" },
              on: { click: _vm.addCategory },
            },
            [_vm._v(" + 添加分类")]
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticClass: "label" }, [_vm._v("分类字号和选中颜色")]),
          _c(
            "el-form-item",
            { attrs: { label: "字号" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 0 },
                model: {
                  value: _vm.value.config.module_name_font_size,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "module_name_font_size", $$v)
                  },
                  expression: "value.config.module_name_font_size",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "色值" } },
            [
              _c("el-color-picker", {
                model: {
                  value: _vm.value.config.module_name_font_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "module_name_font_color", $$v)
                  },
                  expression: "value.config.module_name_font_color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticClass: "label" }, [_vm._v("活动名称字号和颜色")]),
          _c(
            "el-form-item",
            { attrs: { label: "字号" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 0 },
                model: {
                  value: _vm.value.config.activity_name_font_size,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "activity_name_font_size", $$v)
                  },
                  expression: "value.config.activity_name_font_size",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "色值" } },
            [
              _c("el-color-picker", {
                model: {
                  value: _vm.value.config.activity_name_font_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "activity_name_font_color", $$v)
                  },
                  expression: "value.config.activity_name_font_color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "activity_num" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("展示的活动个数")]),
          _c("el-input", {
            attrs: { placeholder: "请输入个数", clearable: "" },
            model: {
              value: _vm.value.config.activity_num,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "activity_num", $$v)
              },
              expression: "value.config.activity_num",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }